import PropTypes from "prop-types";
import React, { useState } from "react";

import { createClassNameString } from "../utils";
import { FormFieldError } from "../FormFields/FormFieldError/FormFieldError";

import "./styles.scss";

export const CurrencyInput = ({
  className,
  errorMessage,
  name,
  onBlur,
  onChange,

  onFocus,
  step,
  value,
  ...props
}) => {
  // since the dollar sign is not part of the input component
  // we need to maintain focus ourselves
  const [isInputFocused, setIsInputFocused] = useState(false);

  const onChangeInternal = (event) => {
    const value = event.target.value;

    if (value.includes(".")) {
      const valueSplit = value.split(".");
      const decimal = valueSplit[1];

      // prevents user from entering in a value that
      // has more than 2 decimal places
      if (decimal.length > 2) {
        return;
      }
    }

    if (onChange) {
      onChange(event);
    }
  };

  const onFocusInternal = () => {
    setIsInputFocused(true);
    if (onFocus) {
      onFocus();
    }
  };

  const onBlurInternal = () => {
    setIsInputFocused(false);
    if (onBlur) {
      onBlur();
    }
  };

  return (
    <div className={createClassNameString(["CurrencyInput-container", className])}>
      <div
        className={createClassNameString([
          "CurrencyInput-text_container",
          errorMessage && "CurrencyInput-text_container-error",
          isInputFocused && "CurrencyInput-text_container-focused",
        ])}
      >
        <p
          className={createClassNameString([
            "CurrencyInput-dollar_sign",
            errorMessage && "CurrencyInput-dollar_sign-error",
          ])}
          data-public
        >
          $
        </p>
        <input
          className={createClassNameString([
            "CurrencyInput-input",
            isInputFocused && "CurrencyInput-input-focused",
          ])}
          data-public
          name={name}
          onBlur={onBlurInternal}
          onChange={onChangeInternal}
          onFocus={onFocusInternal}
          placeholder="0.00"
          step={step}
          type="number"
          value={value}
          {...props}
        />
      </div>
      {errorMessage && <FormFieldError>{errorMessage}</FormFieldError>}
    </div>
  );
};

CurrencyInput.propTypes = {
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,

  onFocus: PropTypes.func,
  step: PropTypes.string,
  // intentionally required, in order for
  // the dollar sign to default to the correct style
  // we need context of what the value is
  value: PropTypes.string.isRequired,
};

CurrencyInput.defaultProps = {
  name: "",
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  step: ".01",
};
